import z, { Infer } from "myzod";

export const weekdaysSchema = z.object({
  Monday: z.boolean(),
  Tuesday: z.boolean(),
  Wednesday: z.boolean(),
  Thursday: z.boolean(),
  Friday: z.boolean(),
  Saturday: z.boolean(),
  Sunday: z.boolean()
});

export type Weekdays = Infer<typeof weekdaysSchema>;

/** Mon–Fri on, weekend off — same as non-weekly defaults in `recurrence-type-picker` (resource booking has no frequency UI). */
export const defaultRecurrenceWeekdays: Weekdays = {
  Monday: true,
  Tuesday: true,
  Wednesday: true,
  Thursday: true,
  Friday: true,
  Saturday: false,
  Sunday: false
};
